/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OrganizationPaymentContractBasicInfoFromJSON, OrganizationPaymentContractBasicInfoToJSON } from './OrganizationPaymentContractBasicInfo';
export function UpdateOrganizationPaymentApplyPlanFreeRequestFromJSON(json) {
    return UpdateOrganizationPaymentApplyPlanFreeRequestFromJSONTyped(json, false);
}
export function UpdateOrganizationPaymentApplyPlanFreeRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        contractBasicInfo: OrganizationPaymentContractBasicInfoFromJSON(json['contract_basic_info'])
    };
}
export function UpdateOrganizationPaymentApplyPlanFreeRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        contract_basic_info: OrganizationPaymentContractBasicInfoToJSON(value.contractBasicInfo)
    };
}
